import { getSimilarVariants } from '../../AttributeSelector/AttributeSelectorHelpers'

const getColourFabricImage = (colour, fabric) => {
  return {
    src: encodeURI(`https://media.4rgos.it/i/Argos/MTO-${colour}-${fabric}`),
    alt: `${colour} ${fabric}`,
    height: 80,
    width: 80,
    cropParams: { xCoord: 0, yCoord: 0, cropWidth: 800, cropHeight: 800 }
  }
}

const getLegFinishImage = (feetColour, partNumber) => {
  return {
    src: encodeURI(`https://media.4rgos.it/i/Argos/${partNumber}_R_Z004A`),
    alt: `${feetColour} feet colour`,
    width: 225
  }
}

// Find the current variant based on the part number
const findCurrentVariant = (variants, currentPartNumber) =>
  variants?.find(variant => variant?.partNumber === currentPartNumber)

const getProductAttributes = product => {
  if (!product) return {}

  const attributes = product?.attributes?.reduce((obj, attr) => {
    const newAttributes = {
      ...obj,
      [attr.type]: attr.value
    }
    return newAttributes
  }, {})

  return attributes
}

// Get the selected fabric type for the attribute selector
const getSelectedFabricType = (productVariants, partNumber) => {
  if (!productVariants || !partNumber) return null

  const currentVariant = findCurrentVariant(productVariants, partNumber)
  const currentProductAttributes = getProductAttributes(currentVariant)

  // The current product attributes values
  const currentFabricType = currentProductAttributes?.['Fabric type']
  const currentColour = currentProductAttributes?.Colour
  const currentFeetColour = currentProductAttributes?.['Feet colour']

  // Only get product variants that match the current products feet colour and size
  const filteredProducts = productVariants.filter(variant => {
    const variantAttributes = getProductAttributes(variant)
    return (
      variantAttributes['Feet colour'] === currentFeetColour && variantAttributes.Size === currentProductAttributes.Size
    )
  })

  // Heading and image for the attribute selector
  const heading = currentFabricType ? `${currentColour} ${currentFabricType}` : ''
  const image = getColourFabricImage(currentColour, currentFabricType)

  return {
    image: { ...image },
    heading,
    optionCount: filteredProducts.length || '',
    type: 'Fabric type'
  }
}

const getSelectedFeetColour = (productVariants, partNumber) => {
  const currentVariant = findCurrentVariant(productVariants, partNumber)
  const currentProductAttributes = getProductAttributes(currentVariant)

  const selectedFeetColour = currentProductAttributes?.['Feet colour']
  const selectedFeetColourImageObject = getLegFinishImage(selectedFeetColour, partNumber)

  // Only get product variants that have similiar variants and has a feet colour value
  const similiarPartNumbers = getSimilarVariants(productVariants, 'Feet colour', partNumber)
  const similarFeetColourVariants = productVariants?.filter(
    product =>
      similiarPartNumbers.includes(product.partNumber) && product.attributes.some(attr => attr.type === 'Feet colour')
  )

  return {
    image: { ...selectedFeetColourImageObject },
    heading: selectedFeetColour || '',
    optionCount: similarFeetColourVariants?.length || '',
    type: 'Feet colour'
  }
}

export { getColourFabricImage, findCurrentVariant, getLegFinishImage, getSelectedFabricType, getSelectedFeetColour }
